import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const InviteSenderProfile = ({ profile, onBack }) => {
  if (!profile) {
    return (
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="w-full max-w-sm p-6 text-center">
        <p className="text-gray-500">Profile not available</p>
        <button onClick={onBack} className="mt-4 text-pink-500 font-semibold">← Back</button>
      </motion.div>
    );
  }

  return (
    <motion.div initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} className="w-full max-w-sm p-6">
      <button onClick={onBack} className="mb-4 text-pink-500 font-semibold flex items-center gap-1">
        <SafeIcon name="ChevronLeft" /> Back to Invitation
      </button>
      <div className="bg-white rounded-2xl border border-gray-200 p-6 text-center">
        <div className="mb-4">
          <p className="text-sm text-purple-500 font-semibold mb-2">Want to know more about them?</p>
        </div>
        <img
          src={profile.avatar_url || `https://ui-avatars.com/api/?name=${encodeURIComponent(profile.name)}&background=random`}
          alt={profile.name}
          className="w-24 h-24 rounded-full mx-auto mb-4 border-4 border-pink-100"
        />
        <h2 className="text-2xl font-bold text-gray-800 mb-1">{profile.name}</h2>
        {profile.age && <p className="text-gray-500 text-sm mb-3">{profile.age} years old</p>}
        {profile.location && (
          <p className="text-gray-500 text-sm mb-4 flex items-center justify-center gap-1">
            <SafeIcon name="MapPin" className="text-pink-400" /> {profile.location}
          </p>
        )}
        {profile.bio && <p className="text-gray-600 text-sm leading-relaxed mb-4 italic">"{profile.bio}"</p>}
        {profile.interests?.length > 0 && (
          <div className="mb-3">
            <p className="text-xs text-gray-400 font-semibold uppercase mb-2">Interests</p>
            <div className="flex flex-wrap gap-2 justify-center">
              {profile.interests.map((interest, i) => (
                <span key={i} className="bg-pink-50 text-pink-600 text-xs px-3 py-1 rounded-full">{interest}</span>
              ))}
            </div>
          </div>
        )}
        {profile.hobbies?.length > 0 && (
          <div>
            <p className="text-xs text-gray-400 font-semibold uppercase mb-2">Hobbies</p>
            <div className="flex flex-wrap gap-2 justify-center">
              {profile.hobbies.map((hobby, i) => (
                <span key={i} className="bg-purple-50 text-purple-600 text-xs px-3 py-1 rounded-full">{hobby}</span>
              ))}
            </div>
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default InviteSenderProfile;